import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  ALL_PLURAL_LABEL,
  INTERNAL_GRADE_LABEL,
  PRACTICE_LABEL,
  RESUME_LABEL,
  EVALUATION_COLLABORATORS_EMPTY_MESSAGE,
  COLLABORATOR_REVIEW_LABEL,
  COLLABORATOR_REVIEW_MESSAGE,
  CAREER_DEVELOPMENT_COMMITTEE_LABEL,
  TO_BE_EXAMINED_LABEL,
  SPEAKER_LABEL,
  CC_LEADER_LABEL,
  CC_MANAGER_LABEL,
  COLLABORATORS_LABEL,
  COMPETENCE_CENTER_LABEL,
  ERROR_LABEL,
  ERROR_MESSAGE_LABEL,
} from "../../constants/Dictionary";
import {
  StyledCollaboratorEvaluation,
  StyledCmCollaboratorContainer,
  StyledCollaboratorContainer,
  StyledCollaboratorSelectContainer,
  StyledSingleCollaboratorContainer,
  StyledInfoCollaboratorContainer,
  StyledEvaluationLeftPanelContainer,
  StyledAccordionWrapper,
  StyledHeader,
  StyledModalBody,
  StyledModalContent,
  StyledAccordionContent,
  StyledCMFollowListContainer,
  StyledSelectAccordion,
  StyledCollaboratorExaminatedDivider,
  StyledHeaderLeftPanel,
  StyledSectionsLeftPanelContainerPractice,
  StyledSectionsLeftPanelContainerSpeaker,
  StyledTitleInternalGrade,
} from "./CalibrationModal.styled";
import { Select, SelectVariantEnum } from "../core/Select/Select";
import { useAppSelector } from "../../hooks/store.hook";
import { Divider } from "../core/Divider/Divider";
import { Accordion, AccordionVariantEnum } from "../core/Accordion/Accordion";
import { BodyTyp } from "../Typography/Typography";
import {
  CollaboratorInfo,
  FontWeightEnum,
  IconSizeEnum,
} from "../../types/AppTypes";
import { IconManager } from "../core/IconManager/IconManager";
import { ReactComponent as AnnouncementIcon } from "../../icons/announcement.svg";
import { ReactComponent as RestoreIcon } from "../../icons/restore2.svg";
import { ReactComponent as FileCheckIcon } from "../../icons/fileCheck.svg";
import { Avatar, AvatarDimensionsEnum } from "../core/Avatar/Avatar";
import { getInitials } from "../../utils/collaborators.utils";
import { EmptyState } from "../EmptyState/EmptyState";
import evaluationCollaboratorsEmpty from "../../images/valutationCollaboratorsEmpty.svg";
import { theme } from "../../constants/StyledComponents";
import { Button, ButtonVariants } from "../core/Button/Button";
import { Timers } from "../Timers/Timers";
import { usePotentialMatrixFilters } from "../../hooks/usePotentialMatrixFilters.hook";
import {
  COLLABORATORS_LIMIT,
  MatrixSizes,
  MatrixViewModeV3,
  typeOptions,
} from "../../constants/PotentialMatrixConstants";
import { ResumePanel } from "../ResumePanel/ResumePanel";
import { ResumeComparison } from "./ResumeComparison/ResumeComparison";
import { CollaboratorsExamined } from "./CollaboratorsExamined/CollaboratorsExamined";
import { PotentialMatrixFilterKeyEnum } from "../../types/api/filters.type";
import {
  CareerDevelopmentCommitteeTypeEnum,
  COLLABORATORS_PAGE_SIZE,
  MATRIX_COLLABORATORS_EXAMINED_PAGE_SIZE,
} from "../../constants/AppConstants";
import { StyledLoaderContainer } from "../../screens/CollaboratorDetail/CollaborProfileTabs/SchedaCM/SchedaCM.styled";
import { Loader } from "../core/Loader/Loader";
import {
  CollaboratorCalibration,
  MatrixDevelopmentItem,
} from "../../types/api/potentialMatrix.type";
import { InfiniteScrollList } from "../InfiniteScrollList/InfiniteScrollList";
import {
  ScreenEnum,
  UpdateCollaboratorResumeRequest,
} from "../../types/api/collaborators.type";
import { HeaderCollaboratorCalibration } from "./HeaderCollaboratorCalibration/HeaderCollaboratorCalibration";
import { PopupConfirm } from "../PopupConfirm/PopupConfirm";
import { usePotentialMatrixStats } from "../../hooks/potentialMatrix.hook";
import {
  useCmFollowList,
  useUpdateCalibration,
  useCmInfiniteList,
  useExaminedCollaboratorsInfinite,
} from "../../hooks/calibrationModal.hook";
import { useUpdateCollaboratorResume } from "../../hooks/collaboratorResume.hook";
import { useNotification } from "../../hooks/notification.hook";
import { ReactComponent as CollaboratorIcon } from "../../icons/users.svg";
import { ModalTextSwitch } from "../core/ModalTextSwitch/ModalTextSwitch";
import { OptionItem } from "../TextSwitch/TextSwitch";
import { MatrixGrid } from "../MatrixGrid/MatrixGrid";
import { usePotentialMatrixDevelopment } from "../../hooks/potentialMatrix/usePotentialMatrixDevelopment.hook";
import { usePracticeCompetenceData } from "../../hooks/potentialMatrix/usePracticeCompetenceData.hook";
import { DevelopmentMatrixDetails } from "../../screens/PotentialMatrixV3/DevelopmentMatrixDetails/DevelopmentMatrixDetails";

type CalibrationModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  year: number;
};

export type PendingCalibration = {
  finalDimensionId: number;
  finalScreen: ScreenEnum;
  finalDimensionPercentage: number;
  finalComment: string | null;
};

export const CalibrationModal = ({
  isOpen,
  closeModal,
  year,
}: CalibrationModalProps) => {
  const { orgSettings } = useAppSelector((state) => state.config);
  const [selectedInternalGrade, setSelectedInternalGrade] = useState<
    string | null
  >("all");
  const [isEvaluationOpen, setIsEvaluationOpen] = useState(true);
  const [isExaminedOpen, setIsExaminedOpen] = useState(false);
  const [selectedCareerManager, setSelectedCareerManager] =
    useState<CollaboratorInfo | null>(null);
  const [selectedCollaborator, setSelectedCollaborator] =
    useState<CollaboratorCalibration | null>(null);
  const [isResumePanelOpen, setIsResumePanelOpen] = useState(false);
  const [comparisonPanelOpen, setComparisonPanelOpen] = useState(false);
  const [comparisonCollaborator, setComparisonCollaborator] =
    useState<CollaboratorInfo | null>(null);
  const [itemDetails, setItemDetails] = useState<MatrixDevelopmentItem | null>(
    null,
  );
  const [displayItem, setDisplayItem] = useState<
    MatrixDevelopmentItem | undefined
  >(undefined);
  const [isAnimatingOpen, setIsAnimatingOpen] = useState(false);
  const [isAnimatingClose, setIsAnimatingClose] = useState(false);
  const [pendingCalibration, setPendingCalibration] =
    useState<PendingCalibration | null>(null);
  const [pendingResume, setPendingResume] =
    useState<UpdateCollaboratorResumeRequest | null>(null);

  const [openModalCollaboratorExaminated, setOpenModalCollaboratorExaminated] =
    useState<boolean>(false);
  const [isCollaboratorExaminated, setIsCollaboratorExaminated] =
    useState<boolean>(false);

  const modalOptions = [
    {
      value: CareerDevelopmentCommitteeTypeEnum.CC_MANAGER,
      label: CC_MANAGER_LABEL,
    },
    {
      value: CareerDevelopmentCommitteeTypeEnum.CC_LEADER,
      label: CC_LEADER_LABEL,
    },
    {
      value: CareerDevelopmentCommitteeTypeEnum.COLLABORATORS,
      label: COLLABORATORS_LABEL,
    },
  ];

  const [selectedModalOption, setSelectedModalOption] = useState<
    OptionItem<CareerDevelopmentCommitteeTypeEnum>
  >(modalOptions[0]);

  const { filters, handleFilters, createQueryParams } =
    usePotentialMatrixFilters({
      currentYear: year,
      internalGrade: ["all"],
      defaultType: typeOptions[1],
      defaultPractice: [orgSettings.areaList.all[0].practiceList[0].id],
    });

  const { CCList } = usePracticeCompetenceData(filters);

  const { data, internalGradeStats, isFetching } =
    usePotentialMatrixDevelopment({
      filters,
      createQueryParams: () =>
        createQueryParams(COLLABORATORS_LIMIT.DEVELOPMENT),
      enabled: itemDetails === null,
    });

  const {
    data: potentialMatrixStatsData,
    isFetching: loadingPotentialMatrixStats,
  } = usePotentialMatrixStats({
    filters,
  });

  const sidePanelRef = useRef<HTMLDivElement>(null);
  const [modalWidth, setModalWidth] = useState(0);

  useEffect(() => {
    if (sidePanelRef.current) {
      const refWidth = sidePanelRef.current.getBoundingClientRect().width;
      setModalWidth(window.innerWidth - refWidth);
    }
  }, [isResumePanelOpen, comparisonPanelOpen]);

  useEffect(() => {
    if (!itemDetails) return;

    setDisplayItem(itemDetails);
    setIsAnimatingClose(false);
  }, [itemDetails]);

  useEffect(() => {
    setItemDetails(null);
    setDisplayItem(undefined);
  }, [filters]);

  useEffect(() => {
    setPendingResume(null);
  }, [selectedCollaborator?.collaborator.id]);

  const times = [2, 3, 5, 10];

  const cmParams = [
    { key: "year", value: [filters.year] },
    ...(filters.practice.length > 0
      ? [{ key: "practice", value: filters.practice }]
      : []),
    { key: "modalGrade", value: [String(selectedModalOption.value)] },
  ];

  const {
    data: calibrationCareerManagers,
    initLoading: calibrationCareerManagersLoading,
    canLoadMore,
    fetchMore,
    fetchingMore,
  } = useCmInfiniteList({
    pageSize: COLLABORATORS_PAGE_SIZE,
    filters: cmParams,
    enabled: isOpen && !!filters.practice[0] && !!selectedInternalGrade,
  });

  const cmParamsFollow = [
    { key: "year", value: [filters.year] },
    ...(filters.practice.length > 0
      ? [{ key: "practice", value: filters.practice }]
      : []),
    ...(selectedInternalGrade && selectedInternalGrade !== "all"
      ? [{ key: "internalGrade", value: [selectedInternalGrade] }]
      : []),
  ];

  const {
    data: calibrationCareerManagersFollow,
    isFetching: calibrationCareerManagersFollowLoading,
  } = useCmFollowList({
    cmId: selectedCareerManager?.id,
    filters: cmParamsFollow,
    enabled: !!selectedCareerManager,
  });

  const isAllInternalGrades = selectedInternalGrade === "all";

  const sortedFollowCollaborators = useMemo(() => {
    const data = calibrationCareerManagersFollow?.data ?? [];
    if (!isAllInternalGrades) return data;
    const gradeOrder = orgSettings.collaborator.internalGrades.map(
      (g) => g.value,
    );
    return [...data].sort((a, b) => {
      const aIdx = gradeOrder.indexOf(a.collaborator.internalGrade ?? "");
      const bIdx = gradeOrder.indexOf(b.collaborator.internalGrade ?? "");
      return aIdx - bIdx;
    });
  }, [
    calibrationCareerManagersFollow,
    isAllInternalGrades,
    orgSettings.collaborator.internalGrades,
  ]);

  const followGradeCounts = useMemo(() => {
    return sortedFollowCollaborators.reduce<Record<string, number>>(
      (acc, item) => {
        const grade = item.collaborator.internalGrade;
        if (grade) acc[grade] = (acc[grade] ?? 0) + 1;
        return acc;
      },
      {},
    );
  }, [sortedFollowCollaborators]);

  const {
    data: examinedCollaborators,
    initLoading: examinedCollaboratorsInitLoading,
    canLoadMore: loadMoreExaminedCollaborators,
    fetchMore: fetchMoreExaminedCollaborators,
    clearSearch: clearExaminedCollaboratorsSearch,
    setSearch: setExaminedCollaboratorsSearchValue,
    search: examinedCollaboratorsSearchValue,
    fetchingMore: fetchingMoreExaminedCollaborators,
    page: examinedCollaboratorsPage,
    pagination: examinedCollaboratorsPagination,
  } = useExaminedCollaboratorsInfinite({
    pageSize: MATRIX_COLLABORATORS_EXAMINED_PAGE_SIZE,
    queryParams: [
      { key: "type", value: [filters.type.value] },
      { key: "practice", value: filters.practice },
      { key: "year", value: [filters.year] },
      { key: "sortBy", value: ["internalGrade"] },
      { key: "sortType", value: ["asc"] },
    ],
    debounce: 500,
  });

  const handleSelectCM = (cm: CollaboratorInfo) => {
    setSelectedCollaborator(null);
    setSelectedCareerManager(cm);
    setIsResumePanelOpen(false);
    setComparisonPanelOpen(false);
    setPendingCalibration(null);
    handleFilters(PotentialMatrixFilterKeyEnum.INTERNAL_GRADE, ["all"]);
  };

  const handleSelectCollaborator = (
    collaboratorCalibration: CollaboratorCalibration,
  ) => {
    setSelectedCollaborator(collaboratorCalibration);
    setIsResumePanelOpen(false);
    setComparisonPanelOpen(false);
    setIsCollaboratorExaminated(false);
    setPendingCalibration({
      finalDimensionId: collaboratorCalibration.calibration.finalDimensionId,
      finalScreen: collaboratorCalibration.calibration
        .finalScreen as ScreenEnum,
      finalDimensionPercentage:
        collaboratorCalibration.calibration.finalDimensionPercentage ??
        collaboratorCalibration.calibration.proposedDimensionPercentage,
      finalComment: collaboratorCalibration.calibration.finalComment ?? null,
    });
  };

  const handleResumeMatrixBox = (collaboratorToCompare: CollaboratorInfo) => {
    setComparisonCollaborator(collaboratorToCompare);

    if (selectedCollaborator) {
      setComparisonPanelOpen(true);
      setIsResumePanelOpen(false);
    }
    if (!selectedCollaborator) {
      setComparisonPanelOpen(false);
      setIsResumePanelOpen(true);
    }
  };

  const handleClickMatrixItem = (item: MatrixDevelopmentItem) => {
    setIsAnimatingOpen(true);
    setItemDetails(item);

    const timeout = setTimeout(() => {
      setIsAnimatingOpen(false);
    }, 500);

    return () => clearTimeout(timeout);
  };

  const handleCloseDetails = () => {
    setIsAnimatingClose(true);

    const timeout = setTimeout(() => {
      setIsAnimatingClose(false);
      setDisplayItem(undefined);
      setItemDetails(null);
    }, 500);

    return () => clearTimeout(timeout);
  };

  const { mutateAsync: updateCalibration, isPending: isUpdatingCalibration } =
    useUpdateCalibration();

  const { notification } = useNotification();

  const { updateResume } = useUpdateCollaboratorResume(
    selectedCollaborator?.collaborator.id ?? 0,
  );

  const handleConfirmCalibration = async () => {
    if (!selectedCollaborator) {
      return;
    }

    if (pendingResume) {
      try {
        await updateResume(pendingResume);
      } catch (error) {
        notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
        return;
      }
    }

    await updateCalibration({
      collaboratorId: selectedCollaborator.collaborator.id,
      filters: [{ key: "year", value: [year.toString()] }],
    });

    setSelectedCollaborator(null);
    setPendingCalibration(null);
    setPendingResume(null);
  };

  const collaboratorsExaminatedProps = {
    examinedCollaboratorsPage,
    fetchingMoreExaminedCollaborators,
    examinedCollaboratorsSearchValue,
    setExaminedCollaboratorsSearchValue,
    clearExaminedCollaboratorsSearch,
    fetchMoreExaminedCollaborators,
    loadMoreExaminedCollaborators,
    examinedCollaboratorsInitLoading,
    examinedCollaborators,
    examinedCollaboratorsPagination,
  };

  const handleConfirmPopup = () => {
    if (selectedCollaborator) {
      handleFilters(PotentialMatrixFilterKeyEnum.INTERNAL_GRADE, [
        selectedCollaborator.collaborator.internalGrade ?? "all",
      ]);
    }
    setIsCollaboratorExaminated(true);
    setOpenModalCollaboratorExaminated(false);
  };

  const handleCancelPopup = () => {
    setOpenModalCollaboratorExaminated(false);
    setSelectedCollaborator(null);
    handleFilters(PotentialMatrixFilterKeyEnum.INTERNAL_GRADE, ["all"]);
  };

  return (
    <>
      <ModalTextSwitch
        fullScreen
        label={CAREER_DEVELOPMENT_COMMITTEE_LABEL}
        isOpen={isOpen}
        closeModal={closeModal}
        dimHeader={isResumePanelOpen || comparisonPanelOpen}
        modalOptions={modalOptions}
        selectedModalOption={selectedModalOption}
        setSelectedModalOption={setSelectedModalOption}
      >
        <StyledModalBody>
          <StyledCollaboratorEvaluation
            ref={sidePanelRef}
            $dimmed={isResumePanelOpen || comparisonPanelOpen}
          >
            <StyledSectionsLeftPanelContainerPractice
              $isOptionCollaborators={
                selectedModalOption.value ===
                CareerDevelopmentCommitteeTypeEnum.COLLABORATORS
              }
              $dimmed={isResumePanelOpen || comparisonPanelOpen}
            >
              <Select
                label={PRACTICE_LABEL}
                variant={SelectVariantEnum.DEFAULT}
                options={orgSettings.areaList.filtered[0].practiceList.map(
                  (item) => ({
                    value: item.id,
                    label: item.name,
                  }),
                )}
                value={filters.practice[0]}
                onChange={(val) =>
                  val
                    ? handleFilters(PotentialMatrixFilterKeyEnum.PRACTICE, [
                        val,
                      ])
                    : handleFilters(PotentialMatrixFilterKeyEnum.PRACTICE, [])
                }
                allowClear={false}
              />
              {selectedModalOption.value ===
                CareerDevelopmentCommitteeTypeEnum.COLLABORATORS && (
                <Select
                  label={COMPETENCE_CENTER_LABEL}
                  variant={SelectVariantEnum.DEFAULT}
                  options={CCList.map((item) => ({
                    value: item.id,
                    label: item.name,
                  }))}
                  value={filters.cc[0] ?? null}
                  onChange={(val) =>
                    handleFilters(
                      PotentialMatrixFilterKeyEnum.COMPETENCE,
                      val ? [val] : [],
                    )
                  }
                  allowClear={false}
                />
              )}
            </StyledSectionsLeftPanelContainerPractice>
            <Divider />
            <StyledSectionsLeftPanelContainerSpeaker>
              <StyledHeaderLeftPanel>
                <IconManager size={IconSizeEnum.SMALL}>
                  <AnnouncementIcon />
                </IconManager>
                <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD}>
                  {SPEAKER_LABEL}
                </BodyTyp>
              </StyledHeaderLeftPanel>
              {calibrationCareerManagers && (
                <InfiniteScrollList
                  items={calibrationCareerManagers}
                  renderItem={(cm) => (
                    <StyledCmCollaboratorContainer
                      key={`${cm.id}-${cm.name}`}
                      $isSelectedCareerManager={
                        selectedCareerManager?.id === cm.id &&
                        selectedCareerManager?.name === cm.name
                      }
                      onClick={() => handleSelectCM(cm)}
                    >
                      <Avatar
                        collaboratorId={cm.id}
                        initials={getInitials(cm.name, cm.surname)}
                        variant={AvatarDimensionsEnum.SMALL}
                      />
                      <BodyTyp>{`${cm.surname} ${cm.name}`}</BodyTyp>
                    </StyledCmCollaboratorContainer>
                  )}
                  onScroll={fetchMore}
                  loading={calibrationCareerManagersLoading}
                  fetchingMore={fetchingMore}
                  canLoadMore={canLoadMore}
                  gapElementList={0}
                />
              )}
            </StyledSectionsLeftPanelContainerSpeaker>
            <Divider />
            <StyledEvaluationLeftPanelContainer
              $isEvaluationOpen={isEvaluationOpen}
              $isExaminedOpen={isExaminedOpen}
            >
              <StyledAccordionWrapper>
                <Accordion
                  label={
                    <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD}>
                      {TO_BE_EXAMINED_LABEL}
                    </BodyTyp>
                  }
                  variant={AccordionVariantEnum.SECONDARY}
                  leftComponent={
                    <IconManager size={IconSizeEnum.SMALL}>
                      <CollaboratorIcon />
                    </IconManager>
                  }
                  onToggle={setIsEvaluationOpen}
                  isOpen={isEvaluationOpen}
                >
                  <StyledAccordionContent>
                    <StyledSelectAccordion>
                      <Select
                        label={INTERNAL_GRADE_LABEL}
                        variant={SelectVariantEnum.DEFAULT}
                        options={[
                          { value: "all", label: ALL_PLURAL_LABEL },
                          ...orgSettings.collaborator.internalGrades,
                        ]}
                        value={selectedInternalGrade}
                        onChange={(val) => setSelectedInternalGrade(val)}
                        allowClear={false}
                      />
                    </StyledSelectAccordion>
                    <StyledCollaboratorContainer>
                      {calibrationCareerManagersFollowLoading && (
                        <StyledLoaderContainer>
                          <Loader
                            loading
                            className="cm-sheet-loader"
                            size={24}
                          />
                        </StyledLoaderContainer>
                      )}
                      {selectedCareerManager &&
                        !calibrationCareerManagersFollowLoading && (
                          <StyledCollaboratorSelectContainer>
                            <StyledCMFollowListContainer>
                              {sortedFollowCollaborators.map((item, index) => {
                                const currentGrade =
                                  item.collaborator.internalGrade;
                                const previousGrade =
                                  sortedFollowCollaborators[index - 1]
                                    ?.collaborator.internalGrade;
                                const showHeader =
                                  isAllInternalGrades &&
                                  !!currentGrade &&
                                  (index === 0 ||
                                    currentGrade !== previousGrade);

                                return (
                                  <Fragment key={item.collaborator.id}>
                                    {showHeader && (
                                      <StyledTitleInternalGrade>
                                        <BodyTyp
                                          variant="2"
                                          fontWeight={FontWeightEnum.SEMIBOLD}
                                        >
                                          {currentGrade}
                                        </BodyTyp>
                                        <BodyTyp
                                          variant="2"
                                          fontWeight={FontWeightEnum.SEMIBOLD}
                                        >
                                          {followGradeCounts[currentGrade]}
                                        </BodyTyp>
                                      </StyledTitleInternalGrade>
                                    )}
                                    <StyledSingleCollaboratorContainer
                                      $isSelectedCollaborator={
                                        selectedCollaborator?.collaborator
                                          .id === item.collaborator.id
                                      }
                                      onClick={() =>
                                        handleSelectCollaborator(item)
                                      }
                                    >
                                      <StyledInfoCollaboratorContainer>
                                        <Avatar
                                          collaboratorId={item.collaborator.id}
                                          initials={getInitials(
                                            item.collaborator.name,
                                            item.collaborator.surname,
                                          )}
                                          variant={AvatarDimensionsEnum.SMALL}
                                        />
                                        <BodyTyp>
                                          {`${item.collaborator.surname} ${item.collaborator.name}`}
                                        </BodyTyp>
                                      </StyledInfoCollaboratorContainer>
                                      {selectedCollaborator?.collaborator.id ===
                                      item.collaborator.id ? (
                                        <IconManager
                                          size={IconSizeEnum.MEDIUM}
                                          color={theme.colors.purple}
                                        >
                                          <RestoreIcon />
                                        </IconManager>
                                      ) : (
                                        <></>
                                      )}
                                    </StyledSingleCollaboratorContainer>
                                  </Fragment>
                                );
                              })}
                            </StyledCMFollowListContainer>
                          </StyledCollaboratorSelectContainer>
                        )}
                      {((!calibrationCareerManagersFollowLoading &&
                        calibrationCareerManagersFollow?.data?.length === 0) ||
                        !selectedCareerManager) && (
                        <EmptyState
                          label={EVALUATION_COLLABORATORS_EMPTY_MESSAGE}
                          imageSrc={evaluationCollaboratorsEmpty}
                          maxWidth={170}
                        />
                      )}
                    </StyledCollaboratorContainer>
                  </StyledAccordionContent>
                </Accordion>
              </StyledAccordionWrapper>
              <Divider />
              <StyledCollaboratorExaminatedDivider
                $isExaminedOpen={isExaminedOpen}
              >
                <CollaboratorsExamined
                  isEvaluationOpen={isEvaluationOpen}
                  onExaminedOpen={setIsExaminedOpen}
                  hiddenCollaborators={filters.hiddenCollaborators}
                  setHiddenCollaborators={(value) =>
                    handleFilters(
                      PotentialMatrixFilterKeyEnum.HIDDEN_COLLABORATORS,
                      value,
                    )
                  }
                  filters={filters}
                  setSelectedCollaborator={setSelectedCollaborator}
                  selectedCollaborator={selectedCollaborator}
                  setOpenModalCollaboratorExaminated={
                    setOpenModalCollaboratorExaminated
                  }
                  setIsEvaluationOpen={setIsEvaluationOpen}
                  handleFilters={handleFilters}
                  setSelectedCareerManager={setSelectedCareerManager}
                  setPendingCalibration={setPendingCalibration}
                  potentialMatrixStatsData={potentialMatrixStatsData ?? []}
                  loadingPotentialMatrixStats={loadingPotentialMatrixStats}
                  {...collaboratorsExaminatedProps}
                />
              </StyledCollaboratorExaminatedDivider>
            </StyledEvaluationLeftPanelContainer>
          </StyledCollaboratorEvaluation>
          <StyledModalContent>
            <StyledHeader>
              <Timers times={times} />
              {selectedCollaborator && (
                <HeaderCollaboratorCalibration
                  selectedCollaborator={selectedCollaborator}
                  openModalCollaboratorExaminated={
                    openModalCollaboratorExaminated
                  }
                  isCollaboratorExaminated={isCollaboratorExaminated}
                  onConfirmCalibration={handleConfirmCalibration}
                  pendingCalibration={pendingCalibration}
                />
              )}
              {selectedCollaborator && (
                <Button
                  label={RESUME_LABEL}
                  variant={ButtonVariants.SECONDARY}
                  onClick={() => setIsResumePanelOpen(true)}
                  icon={<FileCheckIcon />}
                />
              )}
            </StyledHeader>
            {displayItem ? (
              <DevelopmentMatrixDetails
                item={displayItem}
                onClose={handleCloseDetails}
                filters={filters}
                onClickResume={handleResumeMatrixBox}
                matrixData={data ?? []}
                isAnimatingClose={isAnimatingClose}
              />
            ) : (
              <MatrixGrid
                data={data ?? []}
                size={MatrixSizes.BIG}
                viewMode={MatrixViewModeV3.COLLABORATOR}
                internalGradeStats={internalGradeStats}
                loading={isFetching || isUpdatingCalibration}
                onClickResume={handleResumeMatrixBox}
                onClickItem={handleClickMatrixItem}
                selectedItem={itemDetails ?? undefined}
                isAnimatingOpen={isAnimatingOpen}
                {...(selectedCollaborator && {
                  matrixCalibration: {
                    collaborator: selectedCollaborator,
                    onChange: setPendingCalibration,
                    pendingCalibration,
                  },
                })}
              />
            )}
          </StyledModalContent>
          {!comparisonPanelOpen ? (
            <ResumePanel
              key={
                selectedCollaborator?.collaborator.id ??
                comparisonCollaborator?.id
              }
              pendingCalibration={pendingCalibration ?? undefined}
              isOpen={isResumePanelOpen}
              onClose={() => setIsResumePanelOpen(false)}
              width={modalWidth}
              collaboratorId={
                selectedCollaborator
                  ? selectedCollaborator.collaborator.id
                  : comparisonCollaborator
                    ? comparisonCollaborator.id
                    : null
              }
              hideEditButton={!selectedCollaborator}
              {...(selectedCollaborator && {
                onCalibrationChange: setPendingCalibration,
                onResumeChange: setPendingResume,
                pendingResume: pendingResume ?? undefined,
              })}
            />
          ) : null}
          {!isResumePanelOpen ? (
            <ResumeComparison
              pendingCalibration={pendingCalibration ?? undefined}
              currentCollaborator={selectedCollaborator?.collaborator ?? null}
              comparisonCollaborator={comparisonCollaborator ?? null}
              isOpen={comparisonPanelOpen}
              width={modalWidth}
              onClose={() => setComparisonPanelOpen(false)}
            />
          ) : null}
        </StyledModalBody>
      </ModalTextSwitch>
      <PopupConfirm
        label={COLLABORATOR_REVIEW_LABEL}
        isOpen={openModalCollaboratorExaminated}
        onConfirm={() => handleConfirmPopup()}
        onCancel={() => handleCancelPopup()}
        popupText={`${COLLABORATOR_REVIEW_MESSAGE} ${selectedCollaborator?.collaborator.surname} ${selectedCollaborator?.collaborator.name}?`}
      />
    </>
  );
};
